export interface CapitalIncomeTeledeclarationJson {
  recipient_sie?: string;
  code_rof?: string;
  iban?: string;
}

export class CapitalIncomeTeledeclaration {
  constructor(
    public recipientSie?: string,
    public codeRof?: string,
    public iban?: string
  ) {}

  static fromJson(json: Partial<CapitalIncomeTeledeclarationJson>): CapitalIncomeTeledeclaration {
    return new CapitalIncomeTeledeclaration(json.recipient_sie, json.code_rof, json.iban);
  }

  static toJson(teledeclaration: CapitalIncomeTeledeclaration): CapitalIncomeTeledeclarationJson {
    return {
      recipient_sie: teledeclaration.recipientSie,
      code_rof: teledeclaration.codeRof,
      iban: teledeclaration.iban
    };
  }
}
